import { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { BDevice, Label } from '../../../../Components';
import { layoutOpt } from '../../utils/options';
import { PanelRow, SelectControl } from '@wordpress/components';
import Row from '../../settings/Components/Row/Row';
import Column from '../../settings/Components/Column/Column';
const SettingPanel = ({ setData, data }) => {
    const { layout = { desktop: "swipe", tablet: "swipe", mobile: "swipe" } } = data;
    const [device, setDevice] = useState('desktop');

    return <>
        <Row gap={10}>
            <Column span={6}>

                <PanelRow>
                    <Label mt='0'>{__('Layout', 'swipe-n-buy')}</Label>
                    <BDevice device={device} onChange={val => setDevice(val)} />
                </PanelRow>
                <SelectControl className='' options={layoutOpt} value={layout[device]} onChange={(val) => {
                    setData({ ...data, layout: { ...layout, [device]: val } });
                }} />

            </Column>
            <Column span={6}>
            </Column>
        </Row>
    </>
}
export default SettingPanel